<script lang="ts" setup>
import HubContextMenu from '@/modules/Workspaces/KnowledgeHub/Hubs/HubContextMenu.vue'
import HubStatusBadge from '@/modules/Workspaces/KnowledgeHub/Hubs/HubStatusBadge.vue'
import IconSprite from '@/uiKit/IconSprite.vue'
import type { Hub } from './types'

const props = defineProps<{
  hub: Hub
}>()
</script>

<template>
  <div
    class="flex w-full justify-between rounded-2xl bg-background-gray-sunken p-5 hover:bg-background-gray-sunken-hovered"
  >
    <!-- Left side contains the icon and the name -->
    <div class="flex size-full grow items-center justify-start gap-4">
      <IconSprite
        class="size-8 shrink-0 rounded-full bg-background-gray-subtlest text-icon-subtle"
        size="md"
        icon="court"
      />

      <div class="flex w-full shrink grow flex-col">
        <div class="text-md-13px-default text-text">
          {{ hub.name }}
        </div>
        <div class="text-xs-11px-light text-text-subtle">{{ hub.fileCount }} files</div>
      </div>
    </div>

    <!-- Right side contains the status and the options button -->
    <div class="flex items-center gap-1">
      <HubStatusBadge
        :status="props.hub.status"
        @click.prevent.stop
      />
      <HubContextMenu :hub="props.hub" />
    </div>
  </div>
</template>
